const mapping = {
  // POS

  //Till

  // Product > Items
  'ItemEdit':  {
    'add': 'feature:item_management:create',
    'edit': 'feature:item_management:update'
  },
  'ItemView': 'feature:item_management:read',
  'ItemList': 'feature:item_management:read',

  // Product > Pricebooks
  'PriceBookAdd': {
    'add': 'feature:price_management:create',
    'edit': 'feature:price_management:update',
    'renew': 'feature:price_management:update',
  },
  'PriceBookList': 'feature:price_management:read',
  'PriceBookView': 'feature:price_management:read',

  'LabelPrintAdd': {
    'add': 'feature:label_print_management:create',
    'edit': 'feature:label_print_management:update',
  },
  'LabelPrintList': 'feature:label_print_management:read',
  'LabelPrintView': 'feature:label_print_management:read',


  // Product > Item Group Price
  'ItemGroupPriceList': 'feature:item_group_price_management:read',
  'ItemGroupPriceViewWrapper': 'feature:item_group_price_management:read',
  'ItemGroupPriceAddWrapper': {
    'add': 'feature:item_group_price_management:create',
    'edit': 'feature:item_group_price_management:update',
  },

  // Inventory > Adjustment
  'InventoryAdjustment': {
    'add': 'feature:inventory_adjustment:create', 
    'edit': 'feature:inventory_adjustment:update',
  },
  'InventoryAdjustmentList': 'feature:inventory_adjustment:read',
  'InventoryAdjustmentView': 'feature:inventory_adjustment:read',

  // Inventory > Transfer
  'InventoryTransfer': {
    'add': 'feature:inventory_transfer:create',
    'edit': 'feature:inventory_transfer:update',
  },
  'InventoryTransferList': 'feature:inventory_transfer:read',
  'InventoryTransferView': 'feature:inventory_transfer:read',

  // Inventory > Count
  'InventoryStocktake': {
    'add': 'feature:inventory_count:create',
    'edit': 'feature:inventory_count:update',
  },
  'InventoryStocktakeList': 'feature:inventory_count:read',
  'InventoryStocktakeView': 'feature:inventory_count:read',

  // Sale Transaction
  'SaleTransactionList': 'feature:sale_transaction_management:read',
  'SaleTransactionView': 'feature:sale_transaction_management:read',
  'SaleTransactionEdit': 'feature:sale_transaction_management:update',

  // Purchase > Order
  'PurchaseOrder': {
    'add': 'feature:purchase_order_management:create',
    'edit': 'feature:purchase_order_management:update',
  },
  'PurchaseOrderList': 'feature:purchase_order_management:read',
  'PurchaseOrderView': 'feature:purchase_order_management:read',

  // Purchase > Receipt
  'PurchaseReceipt': {
    'add': 'feature:purchase_receipt_management:create',
    'edit': 'feature:purchase_receipt_management:update',
  },
  'PurchaseReceiptList': 'feature:purchase_order_management:read',
  'PurchaseReceiptView': 'feature:purchase_order_management:read',


  // Purchase > Return
    'InventoryReturn': {
      'add': 'feature:purchase_return_management:create',
      'edit': 'feature:purchase_return_management:update',
    },
    'InventoryReturnList': 'feature:purchase_return_management:read',
    'InventoryReturnView': 'feature:purchase_return_management:read',

  // Order Management > Setup
  'OrderManagementEdit': {
    'add': 'feature:order_management:full',
    'edit': 'feature:order_management:full',
  },
  'OrderManagementList': 'feature:order_management:full',
  'OrderManagementView': 'feature:order_management:full',

  // Order Management > Order
  'OrderManagementOrder': 'feature:order_management:read',
  'OrderManagementPickForm': 'feature:order_management:read',
  'OrderManagementPackShipForm': 'feature:order_management:read',

  // Relationships > Customer
  'EditCustomer': {
    'add': 'feature:customer_management:create',
    'edit': 'feature:customer_management:update',
  },
  'CustomerList': 'feature:customer_management:read', 
  'ViewCustomer': 'feature:customer_management:read', 

  // Relationships > Contacts
  'EditContact': {
    'add': 'feature:contact_management:create',
    'edit': 'feature:contact_management:update',
  },
  'ContactList': 'feature:contact_management:read', 
  'ViewContact': 'feature:contact_management:read', 

  // Relationships > Supplier
  'EditSupplier': {
    'add': 'feature:supplier_management:create', 
    'edit': 'feature:supplier_management:update', 
  },
  'SupplierList': 'feature:supplier_management:read', 
  'ViewSupplier': 'feature:supplier_management:read', 


  // Relationships > Employee
  'EditEmployee':  {
    'add': 'feature:employee_management:create',
    'edit': 'feature:employee_management:update'
  },
  'EmployeeList': 'feature:employee_management:read',
  'ViewEmployee': 'feature:employee_management:read',

  // Concessions > Promotions
  'PromotionAdd': 'feature:promotion_management:create',
  'PromotionEdit': 'feature:promotion_management:update',
  'PromotionList': 'feature:promotion_management:read',
  'PromotionView': 'feature:promotion_management:read',

  // Concessions > Loyalty > Purchased Loyalties
  'LoyaltyRedemptionEditWrapper':  {
    'add': 'feature:loyalty_management:create',
    'edit': 'feature:loyalty_management:update'
  },
  'LoyaltyPaymentList': 'feature:loyalty_management:read',
  'LoyaltyRedemptionViewWrapper': 'feature:loyalty_management:read',

  // Concessions > Gift Certificates
  CreditCertificate: {
    'add': 'feature:gift_certificate:create',
    'edit': 'feature:gift_certificate:update'
  },
  CreditCertificateList: 'feature:gift_certificate:read',
  CreditCertificateView: 'feature:gift_certificate:read',

  // Task
  'TaskAddWrapper': 'feature:task_management:create',
  'TaskEditWrapper': 'feature:task_management:update',
  'Tasks': 'feature:task_management:read',
  'TaskViewWrapper': 'feature:task_management:read',

  // Budgets

  // Reports
  'ReportList': 'feature:report_management:read',
  'ReportViewer': 'feature:report_management:read',

  // Reports > Search > Search Records
  'SearchRecordAdd': 'feature:search_records_management:create',
  'SearchRecordEdit': 'feature:search_records_management:update',
  'SearchRecordPreview': 'feature:search_records_management:read',
  'SearchRecordList': 'feature:search_records_management:read',
  'SearchRecordView': 'feature:search_records_management:read',

  // System > Integration
  'Integration': {
    'add': 'feature:integration_management:create',
    'edit': 'feature:integration_management:update',
  },
  'IntegrationView': 'feature:integration_management:read',
  'IntegrationList': 'feature:integration_management:read',

  // System > Event
  'EventView': 'feature:event_management:read',
  'EventEdit': {
    'add': 'feature:event_management:create',
    'edit': 'feature:event_management:update',
  },
  'EventList': 'feature:event_management:read',

  // Integration > Application
  'IntegrationAppAdd': {
    'add': 'feature:integration_management:create',
    'edit': 'feature:integration_management:update',
  },
  'IntegrationAppList': 'feature:integration_management:read',

  // Integration > Import/Export > Import CSV Records
  'CSVAdd': {
    'add': 'feature:csv_management:create',
    'edit': 'feature:csv_management:update',
  },
  'CSVList': 'feature:csv_management:read',

  // Integration > Import/Export > CSV to JSON Import
  'CSVImportForm': 'feature:csv_management:read',

  // Integration > Export
  'ExportCsvAdd': {
    add: 'feature:csv_management:create',
    edit: 'feature:csv_management:update'
  },
  'ExportCsvEdit': {
    add: 'feature:csv_management:create',
    edit: 'feature:csv_management:update'
  },
  'ExportCsvView': 'feature:csv_management:read',
  'ExportCsvList': 'feature:csv_management:read',

  // Integration > Import/Export > Job Status
  // 'JobStatusList': 'feature::read',

  // Integration > Web Services

  // Integration > Users
  // 'EditIntegration': {
    // 'add': 'feature:integtation_management:create',
    // 'edit': 'feature:integration_management:update',
  // },

  // Setup > Company > Subsidiaries
  'EditSubsidiary': {
    'add': 'feature:subsidiary_management:create',
    'edit': 'feature:subsidiary_management:update',
  },
  'SubsidiaryList': 'feature:subsidiary_management:read',
  'ViewSubsidiary': 'feature:subsidiary_management:read',

  // Setup > Company > Location
  'EditLocation': {
    'add': 'feature:location_management:create',
    'edit': 'feature:location_management:update'
  },
  'LocationList': 'feature:location_management:read',
  'ViewLocation': 'feature:location_management:read',

  // Setup > Company > Preferences
  'PreferenceList': 'feature:system_preferences:read',
  'PreferenceDetails': 'feature:system_preferences:read',

  // Setup > Finance > Payment Types
  'EditPaymentType': {
    'add': 'feature:payment_type_management:create',
    'edit': 'feature:payment_type_management:update',
  },
  'PaymentTypeList': 'feature:payment_type_management:read',
  'ViewPaymentType': 'feature:payment_type_management:read',

  // Setup > Finance > Tax Type
  'TaxTypeList': 'feature:tax_management:read',

  // Setup > Finance > Tax Groups
  'TaxGroupList': 'feature:tax_management:read',

  // Setup > Finance > Tax Codes
  'EditTaxCode': {
    'add': 'feature:tax_management:create',
    'edit': 'feature:tax_management:update',
  },
  'TaxCodeList': 'feature:tax_management:read',
  'TaxViewCode': 'feature:tax_management:read',

  // Setup > Finance > Currencies
  'CurrencyEdit': {
    'add': 'feature:currency_management:create',
    'edit': 'feature:currency_management:update'
  },
  'CurrencyList': 'feature:currency_management:read',
  'CurrencyView': 'feature:currency_management:read',

  // Setup > Finance > Exchange Rate
  'ExchangeRateAdd': 'feature:exchange_rate_management:create',
  'ExchangeRateEdit': 'feature:exchange_rate_management:update',
  'ExchangeRateList': 'feature:exchange_rate_management:read',
  'ExchangeRateView': 'feature:exchange_rate_management:read',

  // Setup > Finance > Cash Rounding 
  'CashRoundingList': 'feature:cash_rounding:read',

  // Setup > Security > Roles
  'RolesAdd': {
    'add': 'feature:access_role_management:create',
    'edit': 'feature:access_role_management:update',
  },
  'RolesList': 'feature:access_role_management:read',
  'RolesView': 'feature:access_role_management:read',

  // Setup > Device > Devices
  'DeviceDetail': {
    'add': 'feature:device_management:create',
    'edit': 'feature:device_management:update',
  },
  'DeviceList': 'feature:device_management:read',
  'DeviceView': 'feature:device_management:read',

  // Setup > Device > Device Type
  'DeviceTypeList': 'feature:device_management:read',

  // Setup > Classification > Class
  'EditClassification': {
    'add': 'feature:classification_management:create',
    'edit': 'feature:classification_management:update',
  },
  'ClassificationList': 'feature:classification_management:read',
  'ViewClassification': 'feature:classification_management:read',
  
  // Setup > Classification > Brands
  'BrandList': 'feature:brand_management:read',

  // Setup > Classification > Facet
  'FacetList': 'feature:facet_management:read',

  // Setup > Classification > Region
  'RegionAdd': {
    'add': 'feature:region_management:create',
    'edit': 'feature:region_management:update',
  },
  'RegionList': 'feature:region_management:read', 
  'RegionView': 'feature:region_management:read', 

  // Setup > Classification > Hotkeys
  'NewHotKey': {
    'add': 'feature:hotkey_management:create',
    'edit': 'feature:hotkey_management:update',
  },
  'HotkeyList': 'feature:hotkey_management:read',
  'ViewHotkey': 'feature:hotkey_management:read',

  'EditHotkeyTemplate': {
    'add': 'feature:hotkey_management:create',
    'edit': 'feature:hotkey_management:update',
  },
  'HotkeyTemplateList': 'feature:hotkey_management:read',
  'ViewHotkeyTemplate': 'feature:hotkey_management:read',

  // Setup > Address > Address Type
  'AddressTypeList': 'feature:address_management:read',

  // Setup > Address > Country
  'CountryList': 'feature:address_management:read',

  // Setup > Address > City
  // 'feature:address_management:read'

  // Setup > Address > State
  // 'feature:address_management:read'

  // Setup > Address > Zip Code
  // 'feature:address_management:read'

  // Setup > Lists > Price Level
  'PriceLevelList': 'feature:price_level_management:read',

  // Setup > Lists > Task Types
  'TaskTypeList': 'feature:task_management:read',

  // Setup > Lists > Reason Codes
  'ReasonCodeList': 'feature:reason_code_management:read',

  // Setup > Lists > Relationship Types
  'RelatedEntityTypeList': 'feature:relationship_type_management:read',

  // Setup > Lists > Credit Types
  'CreditTypeList': 'feature:credit_type_management:read',

  // Setup > Lists > Shift Types
  'ShiftTypeList': 'feature:shift_type_management:read',

  // Setup > Lists > Price Group
  'PriceGroupList': 'feature:item_group_price_management:read',

  // Setup > Lists > Order Group
  'OrderGroupList': 'feature:list_management:read',

  // Setup > Lists > Shipping Methods
  'ShippingMethodList': 'feature:list_management:read',

  // Setup > Lists > Unit Of Measure Types
  'UnitOfMeasureTypeList': 'feature:item_management:read',


  // Setup > Matrix > Definition
  'EditMatrixAttribute': {
    'add': 'feature:matrix_definition:create',
    'edit': 'feature:matrix_definition:update',
  },
  'MatrixAttributeList': 'feature:matrix_definition:read',
  'ViewMatrixAttribute': 'feature:matrix_definition:read',

  // Setup > Matrix > Name
  'AttributeNameList': 'feature:matrix_definition:read',
  
  // Setup > Matrix > Values
  'AttributeValueList': 'feature:matrix_definition:read',

  // Setup > Print Templates
  'PrintTemplateForm': {
    'add': 'feature:print_templates:create',
    'edit': 'feature:print_templates:update',
  },
  'PrintTemplateList': 'feature:print_templates:read',
  'PrintTemplateView': 'feature:print_templates:read',

  // Setup > Tools > Custom Fields
  'CustomFieldList': 'feature:tools_management:read',
  'CustomFieldView': 'feature:tools_management:read',
  'CustomFieldEdit': {
    'add': 'feature:tools_management:create',
    'edit': 'feature:tools_management:update',
  },

  // Setup > Tools > Custom Forms
  'CustomFormList': 'feature:tools_management:read',
  'CustomFormView': 'feature:tools_management:read',
  'CustomFormEdit': {
    'add': 'feature:tools_management:create',
    'edit': 'feature:tools_management:update',
  },

  // Setup > Tools > Custom Tabs
  'CustomTabList': 'feature:tools_management:read',
  'CustomTabView': 'feature:tools_management:read',
  'CustomTabEdit': {
    'add': 'feature:tools_management:create',
    'edit': 'feature:tools_management:update',
  },

  // Setup > Tools > Lists
  'ListRecords': 'feature:tools_management:read',
  'ListView': 'feature:tools_management:read',
  'ListEdit': {
    'add': 'feature:tools_management:create',
    'edit': 'feature:tools_management:update',
  },

  // Setup > Shortcuts > Definitions
  'ShortcutDefinitionList': 'feature:tools_management:read',
  'ShortcutDefinitionView': 'feature:tools_management:read',
  'ShortcutDefinition': {
    'add': 'feature:tools_management:create',
    'edit': 'feature:tools_management:update',
  },
  // Setup > Shortcuts > Groups
  'ShortcutGroupList': 'feature:tools_management:read',
}

module.exports = function(page) {
  return mapping[page];
}
